import React from 'react'
import ReactSelect from 'react-select'

const MultiSelect = ({field, validate}) => {
  let hasErrors = field.errors.length > 0 ? true : false

  let options = field.filteredOptions ? field.filteredOptions : field.options;


    for (var key in field.options) {
      if(!field.options[key].value.length){
        field.options[key]['className'] = "m-l-20";
      }
    }

  return (
    <div className={hasErrors ? 'form-group text-danger' : 'form-group'}>
      <label className="col-form-label col-form-label-sm">{field.rules.title}</label>
      <ReactSelect
        placeholder={field.placeholder}
        autosize={false}
        multi
        autoFocus
        options={options}
        simpleValue
        clearable={true}
        name={field.name}
        disabled={false}
        value={field.value}
        onChange={value => validate(value, field)}
        searchable={true}
      />
      {field.errors.map((error, i) => (
        <div key={i} className="form-text text-danger">
          {error}
        </div>
      ))}
    </div>
  )
}

export default (MultiSelect)
